module.exports = __webpack_public_path__ + "static/media/ico-close.047a9c6a.svg";